import React, {h, Component} from 'preact';
import './request-questions-modal.scss';

export default class AlsoBuyingQuestionsModal extends Component {
    state = {
        downPayment: {},
        creditScore: {},
        estimatedPriceRange: {},
        estimatedPriceRangeForLocation: [],
        zipCode: {},
        changed: false,
        // renderDisclosure: false, TODO:: Remove UHL
        alsoBuyingAnswers: {
            estimatedPriceRange: 0,
            preApproved: false
        }
    };

    modalRef;

    ENDPOINT_ADDRESS = 'update-req-thankyou-json';
    FLOW_NAME = 'SellRequest';

    STEPS = {};

    downPayment = {
        text: <span>Down payment</span>,
        onAnswer: answer => {
            this.updateAnswers('downPayment', 'alsoBuyingAnswers.downPayment', answer);
        },
        inputName: 'downPayment',
        subQuestion: 'none',
        // isHomeLoanState: true, TODO:: Remove UHL
        suggestions: [3, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100],
        type: 'select'
    };
    creditScore = {
        text: 'What’s your credit score?',
        onAnswer: answer => {
            this.updateAnswers('creditScore', 'alsoBuyingAnswers.creditScore', answer);
        },
        type: 'select',
        subQuestion: 'none',
        // isHomeLoanState: this.props.isHomeLoansState, TODO:: Remove UHL
        suggestions: [
            'Excellent (740 and above)',
            'Great (700 to 739)',
            'Average (660 to 699)',
            'Below Average (620 to 659)',
            'Below 619'
        ]
    };
    zipCode = {
        text: 'Which ZIP code do you plan to buy in?',
        onAnswer: answer => {
            this.updateAnswers('zipCode', 'alsoBuyingAnswers.zipCode', returnNumbersOnly(answer));
        },
        type: 'zipCode',
        subQuestion: 'none',
        suggestions: ''
        // isHomeLoanState: this.props.isHomeLoansState TODO:: Remove UHL
    };
    estimatedPriceRange = {
        text: 'What is your price range for your new home?',
        type: 'estimatedPriceRange',
        subQuestion: 'none',
        // isHomeLoanState: this.props.isHomeLoansState, TODO:: Remove UHL
        suggestions: this.props.estimatedPriceRangeForLocation,
        onAnswer: answer => {
            this.updateAnswers('estimatedPriceRange', 'alsoBuyingAnswers.estimatedPriceRange', answer);
        }
    };

    constructor(props) {
        super(props);
        this.STEPS.preApproved = this.preApproved;
        this.STEPS.downPayment = this.downPayment;
        this.STEPS.creditScore = this.creditScore;
        this.STEPS.zipCode = this.zipCode;
        this.STEPS.estimatedPriceRange = this.estimatedPriceRange;
    }

    updateAnswers = (question, property, value) => {
        this.setState(
            {
                [question]: {value, property}
            },
            () => {
                this.setState(currentState => ({
                    changed:
                        Object.keys(currentState).filter(key => {
                            const entry = currentState[key];
                            return !!entry.property && typeof entry.value != 'undefined';
                        }).length >= this.props.requiredNumberOfFilledFields
                }));
            }
        );
    };

    submitQuestions = () => {
        const params = {requestId: this.props.requestId};
        Object.keys(this.state).forEach(key => {
            const entry = this.state[key];
            if (entry.property) {
                params[entry.property] = entry.value;
            }
        });
        params['req.alsoBuying'] = true;
        params['alsoBuyingZipcodeAnswer'] = this.state.alsoBuyingAnswers.zipCode;
        $.post(this.ENDPOINT_ADDRESS, params).then(data => {
            let innerParam = {
                requestId: data.requestId
            };
            $.post('checkWinnerQuoteToInitiateSTBOutsideArea-json', innerParam);
            this.handleModalClose();
            this.showAlsoBuyingConfirmationModal(data.alsoBuying, data.alsoBuying ? 'accept' : 'decline');
        });
    };

    showAlsoBuyingConfirmationModal = (isAlsoBuying, renderAction) => {
        var modal = React.createElement(reactComponents.Proposal.AlsoBuyingConfirmationModal, {
            userId: this.props.userId,
            phone: this.props.phone,
            wonAgent: {},
            renderAction: renderAction,
            requestId: this.props.requestId,
            isAlsoBuying: isAlsoBuying
        });
        var $modal = showReactModal(modal);
        $modal.on('hidden.bs.modal', function() {
            window.location.reload();
        });
    };

    handleModalClose = () => {
        if (this.props.onModalClose) {
            setTimeout(() => {
                this.props.onModalClose();
            }, 1000);
        }
    };

    renderQuestions = (question, index) => {
        if (!question || !this.STEPS[question]) {
            return;
        }

        const questionNumber = typeof index !== 'undefined' ? index + 1 : null;
        let {text, subText, inputName, type, onAnswer, suggestions, subQuestion, nextSubQuestion, ...rest} = this.STEPS[
            question
        ];

        const isQuestionAnsweredYes = (this.state[question] || {}).value === true;
        const isQuestionAnsweredNo = (this.state[question] || {}).value === false;

        let priceRangeQuestion = false;
        let showPriceRangeQuestion = false;
        if (this.STEPS[question].type === 'estimatedPriceRange') {
            priceRangeQuestion = true;
            if (this.state.alsoBuyingAnswers.zipCode && this.state.alsoBuyingAnswers.zipCode.length === 5) {
                let params = {
                    zip: this.state.alsoBuyingAnswers.zipCode
                };
                // Default price ranges if we are unable to retrieve based on the zipcode location
                let priceRanges = ['Above $300K', '$200K - $300K', '$100K - $200K', '$100K or less'];
                $.get('getPriceRangeByZipCode-json', params).then(data => {
                    if (data && data.length > 0) {
                        priceRanges = [];
                        for (let d of data) {
                            priceRanges.push(d.rangeStr);
                        }
                        this.state.estimatedPriceRangeForLocation = priceRanges;
                    }
                });
                showPriceRangeQuestion = true;
            }
        }

        return (
            <div className={'question ' + question} key={`${question}-${!!questionNumber || 0}`}>
                {((priceRangeQuestion && showPriceRangeQuestion) || (!priceRangeQuestion && !!text)) && (
                    <div className="question-title">
                        {text} {!!subText && <div className="question-subtitle">{subText}</div>}
                    </div>
                )}
                {type === 'boolean' && (
                    <div className="question-answer-container">
                        <div
                            className={`answer-button radio${isQuestionAnsweredYes ? ' active' : ''}`}
                            onClick={() => onAnswer(true)}>
                            {suggestions ? suggestions[0] : 'Yes'}
                        </div>
                        <div
                            className={`answer-button radio${isQuestionAnsweredNo ? ' active' : ''}`}
                            onClick={() => onAnswer(false)}>
                            {suggestions ? suggestions[1] : 'No'}
                        </div>
                    </div>
                )}
                {type === 'select' && !!suggestions && (
                    <div className="question-answer-container select">
                        <div className="select-wrapper icon-arrow-drop-down">
                            <select className="answer-input" onChange={({target: {value}}) => onAnswer(value)}>
                                <option value="">Select one...</option>
                                {suggestions.map(item => (
                                    <option value={item} key={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
                {type === 'string' && (
                    <div className="question-answer-container">
                        <input
                            type="text"
                            className="answer-input"
                            name={inputName}
                            {...rest}
                            onChange={({target: {value}}) => onAnswer(value)}
                        />
                    </div>
                )}
                {type === 'zipCode' && (
                    <div className="question-answer-container">
                        <input
                            type="text"
                            className="answer-input"
                            name={inputName}
                            maxLength={5}
                            value={this.state.alsoBuyingAnswers.zipCode}
                            onChange={({target: {value}}) => onAnswer(value)}
                            onInput={({target: {value}}) =>
                                this.setState(prevState => {
                                    let alsoBuyingAnswers = Object.assign({}, prevState.alsoBuyingAnswers);
                                    alsoBuyingAnswers.zipCode = returnNumbersOnly(value);
                                    return {alsoBuyingAnswers};
                                })
                            }
                            {...rest}
                        />
                    </div>
                )}
                {type === 'estimatedPriceRange' && showPriceRangeQuestion && (
                    <div className="question-answer-container select">
                        <div className="select-wrapper icon-arrow-drop-down">
                            <select className="answer-input" onChange={({target: {value}}) => onAnswer(value)}>
                                <option value="">Select one...</option>
                                {this.state.estimatedPriceRangeForLocation.map(item => (
                                    <option value={item} key={item}>
                                        {item}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // TODO:: Remove UHL
    // renderDisclosureContent = () => (
    //     <div className="modal-body">
    //         {!this.props.renderDisclosure && (
    //             <div onClick={() => this.setState({renderDisclosure: false})} className="back-btn">
    //                 <i className="icon-arrow-direct-left" /> Back
    //             </div>
    //         )}
    //         {this.props.renderBack && (
    //             <div onClick={() => this.props.onBack()} className="back-btn">
    //                 <i className="icon-arrow-direct-left" /> Back
    //             </div>
    //         )}
    //         <div className="disclosure-header">
    //             <h5>Affiliated Business Arrangement Disclosure</h5>
    //         </div>
    //
    //         <div className="disclosure-wrapper">
    //             <div className="disclosure-content">
    //                 Dear Home Buyer,
    //                 <br></br>
    //                 This is to give you notice that UpNest, Inc. ("UpNest") has a business relationship with UpNest Home
    //                 Loans, LLC (UpNest Home Loans"). UpNest Home Loans is a wholly owned subsidiary of UpNest. Because
    //                 of this relationship, this referral may provide UpNest with a financial or other benefit. Set forth
    //                 below is the estimated charge or range of charges for the lender fees listed. You are NOT required
    //                 to use the listed provider as a condition for the purchase, sale, or refinance of the subject
    //                 property. THERE ARE FREQUENTLY OTHER PROVIDERS AVAILABLE WITH SIMILAR SERVICES. YOU ARE FREE TO SHOP
    //                 AROUND TO DETERMINE THAT YOU ARE RECEIVING THE BEST SERVICES AND THE BEST RATE FOR THESE SERVICES.
    //                 <br></br>
    //                 <br></br>
    //                 UpNest Home Loans:
    //                 <ul>
    //                     <li>Origination/Underwriting Fee: $0</li>
    //                     <li>Application Fee: $0</li>
    //                     <li>Processing Fee: $0</li>
    //                 </ul>
    //                 <br></br>
    //                 ACKNOWLEDGEMENT
    //                 <br />
    //                 <br></br>
    //                 By closing out of this screen you acknowledge that you have read this disclosure, and understand
    //                 that UpNest is referring you to purchase the above-described settlement service and may receive a
    //                 financial or other benefit as the result of this referral.
    //                 <br />
    //                 <br />
    //                 <div className="disclosure-header">
    //                     <h5>Disclosures and assumptions</h5>
    //                 </div>
    //                 <p>
    //                     By clicking Apply Now or by downloading your pre-qualification letter, you consent to us sending
    //                     your personal information including but not limited to your First Name, Last Name, City & State,
    //                     Price Range, Credit Score Range, Email Address, and Phone Number to Floify, our mortgage
    //                     processing partner, to begin initial assessment.
    //                 </p>
    //                 <p>
    //                     Rates updated daily and are subject to change without notice. The estimates displayed here are
    //                     not a substitute for a Loan Estimate, which includes an estimate of closing costs you will
    //                     receive once you apply for a loan. The actual fees, costs, and monthly payment on your specific
    //                     loan transaction may vary and may include city, county, or other additional fees and costs.
    //                 </p>
    //                 <p>
    //                     The Annual Percentage Rates (APR) is a measure of the cost to borrow money expressed as a yearly
    //                     percentage. It includes the interest rate plus the following charges or fees: mortgage
    //                     insurance, discount points, and origination fees.
    //                 </p>
    //                 <p>Estimated rates are based on the following additional assumptions:</p>
    //                 <ul>
    //                     <li>Credit score of 740 or greater</li>
    //                     <li>Home value: $500,000</li>
    //                     <li>Loan amount: {(this.props.ratesData || {}).loan_amount || '$300,000'}</li>
    //                     <li>40% down payment or 60% loan to value.</li>
    //                     <li>
    //                         Discount Points (Discount points are charges paid to the lender voluntarily, usually at
    //                         closing by the borrower or seller, to reduce the interest rate. One point is equal to 1% of
    //                         the principal amount of the mortgage).
    //                     </li>
    //                     <li>Property located in IL</li>
    //                     <li>Lock period: 30 days</li>
    //                     <li>Lien Position: First</li>
    //                     <li>Property type: Single-Family Residence</li>
    //                     <li>Property usage: Primary Residence</li>
    //                     <li>
    //                         Escrow account applied (meaning your tax and insurance costs are collected monthly with your
    //                         mortgage payment)
    //                     </li>
    //                     <li>Product: Conventional Loan</li>
    //                 </ul>
    //             </div>
    //         </div>
    //     </div>
    // );

    render() {
        return (
            <div
                ref={ref => (this.modalRef = ref)}
                className={`modal nu-modal fade in request-questions-popup modal`}
                // TODO:: Remove UHL
                // className={`modal nu-modal fade in request-questions-popup modal ${
                //         this.state.renderDisclosure ? ' affiliate-disclosure-modal' : ''
                // }`}

                role="dialog"
                style="display: block;">
                <div className="nu-modal-content">
                    <div className="modal-dialog">
                        <div className="modal-content side-by-side">
                            <div className="modal-header text-center">
                                <h4>Thousands of happy home buyers have used Realtor.com</h4>
                                <div className="review-block">
                                    <div className="stars">
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                        <i className="icon-star-filled" />
                                    </div>
                                    <p className="review-content">
                                        “Best part was getting commission proposals right away. Very convenient, saves
                                        time. I also like seeing a brief video/audio clip, along with the services they
                                        offer. This helped me narrow down to a few potential agents I wanted to meet.”
                                    </p>
                                    <p className="review-footer">
                                        <b>Stephanie Murrin</b>
                                        <br />
                                        Colts Neck, NJ
                                    </p>
                                </div>
                                {/*TODO:: Remove UHL*/}
                                {/*{this.props.isHomeLoansState && !this.state.renderDisclosure && (*/}
                                {/*    <div*/}
                                {/*        onClick={() => {*/}
                                {/*            trackEvent('Proposal', 'HomeLoan', 'buyerSeenHomeLoansDisclosurePopup');*/}
                                {/*            this.setState({renderDisclosure: true});*/}
                                {/*        }}*/}
                                {/*        className="link-text">*/}
                                {/*        See disclosures and assumptions <i className="icon-arrow-direct-right" />*/}
                                {/*    </div>*/}
                                {/*)}*/}
                            </div>

                            {/*TODO:: Remove UHL*/}
                            {/*{this.state.renderDisclosure ? (*/}
                            {/*    this.renderDisclosureContent()*/}
                            {/*) : (*/}
                            <div className="modal-body">
                                <p className="status-message">Thank you! Your request has been submitted.</p>
                                <h4 className="form-header">Are You Also Buying a Home?</h4>
                                <div className="questions-container">
                                    {Object.keys(this.STEPS)
                                        // TODO:: Remove UHL
                                        // .filter(
                                        //     key => this.STEPS[key].isHomeLoanState === this.props.isHomeLoansState
                                        // )
                                        .map((step, index) => this.renderQuestions(step, index))}
                                </div>
                                <div className="modal-footer">
                                    <div className="modal-actions-container row">
                                        <button
                                            type="button"
                                            className={`btn btn-default pull-right${
                                                this.state.changed ? '' : ' disabled'
                                            }`}
                                            id="prefillCommTiers"
                                            onClick={() => {
                                                trackEvent('Flow', this.FLOW_NAME, 'sellerAlsoBuyingPopUp', {
                                                    submit: 'submit'
                                                }).withGA();
                                                this.submitQuestions();
                                            }}>
                                            Submit
                                            <i className="icon-arrow-direct-right" />
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-cancel pull-right"
                                            aria-label="Close"
                                            onClick={() => {
                                                trackEvent('Flow', this.FLOW_NAME, 'sellerAlsoBuyingPopUp', {
                                                    scip_for_now: 'scip_for_now'
                                                }).withGA();
                                                this.handleModalClose();
                                            }}>
                                            Skip for now
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/*)}*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
